export function getDateWithFormat(date: Date) {
    const dateDay = date.getDate();
    const dateMonth = date.getMonth();
    const dateYear = date.getFullYear();
    return `${dateYear}-${(dateMonth + 1).toString().padStart(2)}-${dateDay}`;
}

export function getTimeWithFormat(date: Date) {
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
}
